import React from 'react'
import { Block, api } from 'xadmin'
import { C } from 'xadmin-ui'
import { AppProvider } from '../../dashboard/AppPage'

const CustomApp = props => {
  const { id, parentChildrens } = props
  const [dashboard, setDashboard] = React.useState(null)

  React.useEffect(() => {
    api({ name: 'core/dashboard' }).get(id).then(res => {
      setDashboard(res)
    })
  }, [id])

  return (
    <AppProvider parentChildrens={parentChildrens}>
      <Block name="main" />
      {dashboard ? <C is="DashboardPageView" item={dashboard} isNoRecoilRoot={true} /> : null}
    </AppProvider>
  )
}

export default CustomApp
